const nonEssentialCookies = [
  // Google Analytics
  '_ga',
  '_gid',
  '_gat',
  '_gac_',
  'AMP_TOKEN',
  '__utma',
  '__utmb',
  '__utmc',
  '__utmt',
  '__utmz',
  '__utmv',
  'lh_ga_cookie',
  // Google Tag Manager
  '_gcl_au',
  '_fbp',
  '_fbc',
  'lh_gtm_cookie',
  // GoDaddy Analytics
  '_tccl_visitor',
  '_tccl_visit',
  '_scc_session',
  '@@scroll|/|initial',
];

const essentialCookies = [
  'cookiePreferences',
  'cookieConsentVersion'
];

export function initCookieManager() {
  const hasConsent = () => {
    try {
      const preferences = JSON.parse(localStorage.getItem('cookiePreferences'));
      return preferences && preferences.analytics;
    } catch {
      return false;
    }
  };

  // Interceptar document.cookie
  const originalCookie = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
  Object.defineProperty(document, 'cookie', {
    get() {
      return originalCookie.get.call(this);
    },
    set(value) {
      const cookieName = value.split('=')[0].trim();
      
      // Permitir cookies esenciales
      if (essentialCookies.includes(cookieName)) {
        originalCookie.set.call(this, value);
        return;
      }
      
      // Bloquear cookies no esenciales si no hay consentimiento
      if (!hasConsent() && nonEssentialCookies.some(c => cookieName.startsWith(c))) {
        console.log('Cookie bloqueada:', cookieName);
        return;
      }
      
      // Permitir otras cookies
      originalCookie.set.call(this, value);
    }
  });
} 